const StyleObjectProperty = 0,
  StyleObjectValue = 1,
  StyleObjectIdentifier = 2,
  StyleObjectPseudo = 3,
  StyleObjectRules = 4;
export { StyleObjectIdentifier, StyleObjectProperty, StyleObjectPseudo, StyleObjectRules, StyleObjectValue };
//# sourceMappingURL=types.mjs.map
